/**
 * Document Imports Vuex Getters
 * Computed state properties for the document import feature.
 */

export default {
  // === Dialog State ===
  GET_UPLOAD_DIALOG_OPEN: state => state.uploadDialogOpen,

  // === Wizard State ===
  GET_WIZARD_STEP: state => state.wizardStep,

  // === Scope ===
  GET_SCOPE_TYPE: state => state.scopeType,
  GET_SELECTED_FACILITY_ID: state => state.selectedFacilityId,
  GET_SELECTED_FACILITY_GROUP_ID: state => state.selectedFacilityGroupId,

  // Selected target ID (works for both scope types)
  GET_SELECTED_TARGET_ID: state => {
    return state.scopeType === 'Facility'
      ? state.selectedFacilityId
      : state.selectedFacilityGroupId;
  },

  // === Upload Configuration ===
  GET_SELECTED_DOCUMENT_TYPE_ID: state => state.selectedDocumentTypeId,

  // === Pending Files ===
  GET_PENDING_FILES: state => state.pendingFiles,
  GET_PENDING_FILES_COUNT: state => state.pendingFiles.length,
  GET_SELECTED_FILE_INDEXES: state => state.selectedFileIndexes,
  GET_SELECTED_FILES_COUNT: state => state.selectedFileIndexes.length,

  // Check if any pending files have validation errors
  GET_HAS_INVALID_FILES: state => {
    return state.pendingFiles.some(f => !f.isValid || (f.errors && f.errors.length > 0));
  },

  // Check if can submit import
  GET_CAN_SUBMIT_IMPORT: (state, getters) => {
    const hasFiles = state.pendingFiles.length > 0;
    const hasTarget = getters.GET_SELECTED_TARGET_ID != null;
    const noErrors = !getters.GET_HAS_INVALID_FILES;
    const notImporting = !state.importing && !state.uploading;

    return hasFiles && hasTarget && noErrors && notImporting;
  },

  // === Existing Documents ===
  GET_DOCUMENTS: state => state.documents,
  GET_DOCUMENTS_TOTAL: state => state.documentsTotal,

  // === Table Options ===
  GET_TABLE_OPTIONS: state => state.tableOptions,

  // === Document Types ===
  GET_DOCUMENT_TYPES: state => state.documentTypes,
  GET_DOCUMENT_TYPES_LOADED: state => state.documentTypesLoaded,

  // Get document type by ID
  GET_DOCUMENT_TYPE_BY_ID: state => id => {
    return state.documentTypes.find(t => t.id === id);
  },

  // Document types as select options
  GET_DOCUMENT_TYPE_OPTIONS: state => {
    return state.documentTypes.map(t => ({
      text: t.name,
      value: t.id,
    }));
  },

  // === Loading States ===
  GET_LOADING: state => state.loading,
  GET_UPLOADING: state => state.uploading,
  GET_IMPORTING: state => state.importing,
  GET_DELETING: state => state.deleting,

  // Combined loading state
  GET_IS_BUSY: state => {
    return state.loading || state.uploading || state.importing || state.deleting;
  },

  // === Error State ===
  GET_ERROR: state => state.error,
  GET_HAS_ERROR: state => !!state.error,

  // === Import Result ===
  GET_IMPORT_RESULT: state => state.importResult,
};
